import React from 'react';
import { PAGE_SIZE } from './transactionPages';

// Previous/Next controls under the Transactions table.
export default function TransactionPager({ page, total, onPage }) {
  if (total === null || total <= PAGE_SIZE) return null;
  const first = page * PAGE_SIZE + 1;
  const last = Math.min((page + 1) * PAGE_SIZE, total);
  return (
    <div className="flex items-center justify-between mt-3 text-sm text-gray-600">
      <span>
        Showing {first}–{last} of {total}
      </span>
      <div className="space-x-2">
        <button type="button" className="px-3 py-1 border rounded disabled:opacity-50" disabled={page === 0} onClick={() => onPage(page - 1)}>Previous</button>
        <button type="button" className="px-3 py-1 border rounded disabled:opacity-50" disabled={last >= total} onClick={() => onPage(page + 1)}>Next</button>
      </div>
    </div>
  );
}
